import { render } from "./DateBrowseItem.vue?vue&type=template&id=c82805b6"
import script from "./DateBrowseItem.vue?vue&type=script&lang=js"
export * from "./DateBrowseItem.vue?vue&type=script&lang=js"
script.render = render

export default script